import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "m23.75 16.79-11-12.47a1.06 1.06 0 0 0-1.54 0L.25 16.79a1 1 0 0 0-.25.73 1 1 0 0 0 .36.69l1.85 1.55A1 1 0 0 0 3 20a1 1 0 0 0 .69-.35l8.17-9.45a.27.27 0 0 1 .38 0l8.17 9.45a1 1 0 0 0 .69.35 1 1 0 0 0 .74-.23l1.85-1.56a1 1 0 0 0 .36-.69 1 1 0 0 0-.3-.73"
    }, null, -1)
  ]));
}
const arrowChevronUp = { render };
export {
  arrowChevronUp as default,
  render
};
//# sourceMappingURL=arrow-chevron-up.svg.js.map
